import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

// @mui
import {
  Link,
  Stack,
  IconButton,
  InputAdornment,
  TextField,
  Checkbox,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Slide,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import api from '../../../api';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'; // Import the utc plugin
dayjs.extend(utc); // Extend dayjs with the utc plugin
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';
import moment from 'moment';
import EditBidForm from './EditBidForm';

// components

// ----------------------------------------------------------------------

export default function DeclareForm({ selectedGame }) {
  // States for input fields

  const [filterDate, setFilterDate] = useState();
  const [session, setSession] = useState('');
  const [gameId, setGameID] = useState(selectedGame?.master_game_id || '');
  const [panna, setPanna] = useState('');
  const [digit, setDigit] = useState('');
  const [data, setData] = useState('');
  const [masterGameData, setMasterGameData] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const getAllMasterGames = async () => {
    const response = await api.get('/master-games');
    setMasterGameData(response.data.results);
  };

  useEffect(() => {
    getAllMasterGames();
  }, []);

  const handleGameCreate = async () => {
    const reqBody = {
      game_id: gameId,
      session: session,
      open_panna: session === 'open' ? panna : '',
      open_digit: session === 'open' ? digit : '',
      close_panna: session === 'close' ? panna : '',
      close_digit: session === 'close' ? digit : '',
      master_game_created_date: selectedGame?.game_update_at || filterDate || moment.utc(new Date()),
    };

    if (!reqBody?.master_game_created_date) {
      alert('Please select date!');
      return;
    }

    if (!session) {
      alert('Please select session!');
      return;
    }

    if (panna.length !== 3) {
      alert('Pana should be 3 char long!');
      return;
    }

    // handleClose();
    setLoading(true);

   try {
    let res = await api.post('/declare-results', reqBody);
    setTimeout(() => {
      window.location.reload();
    }, 100);


    if (res.data) {
      setData(res.data);
    }
   } catch (error) {
    setLoading(false);

   }
  

  };

  const getAllShowWinners = async () => {
    const reqBody = {
      game_id: gameId,
      session: session,
      open_panna: session === 'open' ? panna : '',
      open_digit: session === 'open' ? digit : '',
      close_panna: session === 'close' ? panna : '',
      close_digit: session === 'close' ? digit : '',
      master_game_created_date: filterDate ? moment.utc(filterDate) : moment.utc(selectedGame?.game_update_at),
    };

    if (!reqBody?.master_game_created_date) {
      alert('Please select date!');
      return;
    }

    if (!session) {
      alert('Please select session!');
      return;
    }

    if (panna.length !== 3) {
      alert('Pana should be 3 char long!');
      return;
    }

    setLoading(true);
    // handleClose();
    let res = await api.post('/declare-results/show-all-winners', reqBody);

    if (res.data?.results) {
      setData(res.data.results);
    }
    setLoading(false);

    if (res.data.error) {
      alert(res.data.error);
      return;
    }
    // setTimeout(() => {
    //   window.location.reload();
    // }, 500);
  };

  const panaHandler = (e) => {
    if (!session) {
      alert('Please select session');
      return;
    }

    let res = e.target.value?.split('').reduce((acc, cur) => {
      return Number(acc) + Number(cur);
    }, 0);

    setPanna(e.target.value);

    if (e.target.value.length === 3) {
      let newRes = String(res);
      if (newRes?.length === 1) {
        setDigit(newRes);
        return;
      }
      if (session === 'open') {
        setDigit(newRes[1]);
      } else if (session === 'close') {
        setDigit(newRes[1]);
      }
    } else {
      setDigit('');
    }
  };

  return (
    <>
      <Stack spacing={3} my={2}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DemoContainer components={['DatePicker']}>
            <DatePicker
              defaultValue={dayjs.utc(selectedGame ? selectedGame.game_update_at : new Date())}
              label="Select Date"
              value={filterDate}
              onChange={(newValue) => {
                setFilterDate(newValue);
              }}
            />
          </DemoContainer>
        </LocalizationProvider>

        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Select Game</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={gameId}
            label="Select Game"
            onChange={(e) => setGameID(e.target.value)}
          >
            {masterGameData?.map((item) => {
              return (
                <MenuItem key={item._id} value={item._id}>
                  {item.game_name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Session</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={session}
            label="Session"
            onChange={(e) => setSession(e.target.value)}
          >
            <MenuItem disabled={selectedGame && !selectedGame?.is_open_pending} value={'open'}>
              Open
            </MenuItem>
            <MenuItem disabled={selectedGame && !selectedGame?.is_close_pending} value={'close'}>
              Close
            </MenuItem>
          </Select>
        </FormControl>

        <TextField
          inputProps={{ maxLength: 3 }}
          name="pana"
          label="Pana"
          value={panna}
          onChange={(e) => panaHandler(e)}
        />
        <TextField
          InputLabelProps={{
            shrink: true,
          }}
          name="digit"
          label="Digit"
          disabled
          value={digit}
        />
      </Stack>

      {data.length > 0 && (
        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
          <TableContainer component={Paper}>
            <Table aria-label="spanning table">
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Session</TableCell>
                  <TableCell>Open Digit</TableCell>
                  <TableCell>Open Panna</TableCell>
                  <TableCell>Close Digit</TableCell>
                  <TableCell>Close Panna</TableCell>
                  <TableCell>Bid Points</TableCell>
                  <TableCell>Won Points</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>{moment(item.createdAt).format('MMM, DD,YYYY, hh:mm a')}</TableCell>
                      <TableCell>{item?.session?.toUpperCase()}</TableCell>
                      <TableCell>{item.open_digit || '-'}</TableCell>
                      <TableCell>{item.open_panna || '-'}</TableCell>
                      <TableCell>{item.close_digit || '-'}</TableCell>
                      <TableCell>{item.close_panna || '-'}</TableCell>
                      <TableCell>{item.points}</TableCell>
                      <TableCell>{item.pointsWon}</TableCell>
                      <TableCell>
                        <Stack direction="row">
                          <EditBidForm getAllShowWinners={getAllShowWinners} item={item} selectedGame={selectedGame} />
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Stack>
      )}
      <Stack direction="row">
        <LoadingButton
          loading={loading}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
          onClick={getAllShowWinners}
        >
          Show Winners
        </LoadingButton>
        <LoadingButton
          style={{
            marginLeft: 10,
          }}
          fullWidth
          loading={loading}
          size="large"
          color="success"
          type="submit"
          variant="contained"
          onClick={handleGameCreate}
        >
          Declare Result
        </LoadingButton>
      </Stack>
    </>
  );
}
